import { useState, useEffect } from 'react';
import apiClient from '../services/api/apiClient';
import { useAuth } from '../contexts/AuthContext';

export const useUserAccounts = () => {
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { isAuthenticated } = useAuth();

  const fetchAccounts = async () => {
    try {
      setLoading(true);
      console.log(' [useUserAccounts] Fetching accounts from /user/social-accounts/account-settings...');
      const response = await apiClient.get('/user/social-accounts/account-settings');
      console.log('✅ [useUserAccounts] Response:', response.data);
      if (response.data.success) {
        const accountsList = response.data.data || response.data.accounts || [];
        setAccounts(accountsList);
        console.log('📦 [useUserAccounts] Accounts loaded:', accountsList.length, 'accounts');
      } else {
        console.warn('⚠️ [useUserAccounts] API returned success=false');
      }
    } catch (error) {
      console.error('❌ [useUserAccounts] Failed to fetch accounts:', error);
      console.error('❌ [useUserAccounts] Error details:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        url: error.config?.url
      });
      setError(error);
      setAccounts([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!isAuthenticated) {
      setLoading(false);
      return;
    }

    fetchAccounts();
  }, [isAuthenticated]);

  const hasAccounts = accounts.length > 0;
  const hasActiveAccounts = accounts.filter(account => account.status === 'active').length > 0;

  return {
    accounts,
    loading,
    error,
    hasAccounts,
    hasActiveAccounts,
    refetch: () => {
      if (isAuthenticated) {
        setLoading(true);
        setError(null);
        fetchAccounts();
      }
    }
  };
};